import { uploadImage } from '@/api/uploadImage';
import { uploadThumbnail } from '@/api/uploadVideoThumbnail';
import { getVideoCover } from '@/utils/getVideoCover';
import React, { useState } from 'react';

export const useSelectMultipleFile = () => {
  const [images, setImages] = useState<string[]>([]);
  const [uploaded, setUploaded] = useState<any[]>([]);
  const [load, setload] = useState<boolean>(false);
  const [text, setText] = useState<any[]>([]);
  const [about, setAbout] = useState<any[]>([]);
  const [file, setFile] = useState<File | null>(null);
  const [pdfNames, setpdfNames] = useState<any[]>([]);

  const [cover, setCover] = useState<string>();
  const [size, setSize] = useState();
  const [pdfName, setpdfName] = useState<string>();

  const [thumbnail, setThumbnail] = useState<string>();
  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const previews = [];
    const texts = text;
    const abouts = about;
    const uploads = uploaded;
    const files = e?.target?.files ?? [];

    for (const file of files) {
      if (file) {
        setload(true);
        const preview = URL.createObjectURL(file);
        previews.push(preview);
        texts.push('');
        abouts.push('');
        const res = await uploadImage({ file });
        uploads.push(res.url);
        setload(false);
        const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
        const fileSize: any = fileSizeInMB?.toFixed(3);
        setSize(fileSize);

        if (isVideo(file.name)) {
          const cov = await getVideoCover(file, 1.5);
          setCover(cov);
          const data = await uploadThumbnail(cov);
          setThumbnail(data?.url);
        }
        if (isPdf(file.name)) {
          const pdfName = file.name;
          pdfNames.push(pdfName);
          setpdfName(pdfName.replace(/\.[^/.]+$/, ''));
        }
      }
    }
    setUploaded(uploads);
    setload(load);
    setText(texts);
    setImages(images.concat(previews));
    setpdfNames(pdfNames);
  };

  const deleteImage = (val: number) => {
    const filteredItems = images.filter((i, index) => index !== val);
    const uploadsItems = uploaded.filter((i, index) => index !== val);
    const filteredNames = text.filter((i, index) => index !== val);
    const filteredAbouts = about.filter((i, index) => index !== val);
    const filteredPdfs = pdfNames.filter((i, index) => index !== val);
    setText(filteredNames);
    setAbout(filteredAbouts);
    setImages(filteredItems);
    setUploaded(uploadsItems);
    setpdfNames(filteredPdfs);
  };

  return {
    file,
    images,
    load,
    handleChange,
    setImages,
    setpdfNames,
    setFile,
    uploaded,
    deleteImage,
    text,
    about,
    setAbout,
    setText,
    pdfNames,
    size,
    cover,
    pdfName,
    thumbnail,
  };
};

export function getExtension(filename: string) {
  const parts = filename.split('.');
  return parts[parts.length - 1];
}

export function isImage(filename: string) {
  const ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'jpg':
    case 'gif':
    case 'bmp':
    case 'png':
      //etc
      return true;
  }
  return false;
}

export function isVideo(filename: string) {
  const ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'm4v':
    case 'avi':
    case 'mpg':
    case 'mp4':
    case 'webm':
      // etc
      return true;
  }
  return false;
}

export function isPdf(filename: string) {
  const ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'pdf':
    case 'doc':
    case 'docx':
    case 'txt':
    case 'rtf':
    case 'xls':
    case 'xlsx':
    case 'csv':
      //etc
      return true;
  }
  return false;
}
